// extracted by mini-css-extract-plugin
module.exports = {"profileStyle":"SCW4zhfe1v5d9NizsJWjn","deleteClientStyle":"_3YqphGI69ziLzgy0ggNnSM"};